import axios from "./axios";

export async function fetchProjectCategories(controller) {
  return axios({
    method: "get",
    url: "/project_categories",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchProjectCategory(id) {
  return axios.get(`/project_categories/` + id);
}

export async function createProjectCategory(payload) {
  return axios
    .post(`/project_categories`, { project_category: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateProjectCategory(payload) {
  return axios
    .put(`/project_categories/${payload.id}`, { project_category: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteProjectCategory(payload) {
  return axios
    .delete(`/project_categories/${payload.id}`, {
      data: JSON.stringify({
        project_category: payload,
      }),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
